export const ledgersSubMenu = [{
  path: '/ledgers/list',
  component: () => import('@/views/ledgers/list.vue'),
  name: 'Ledger',
  meta: {
    roles: ['Super Admin', 'Admin', 'Agent', 'Branch Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Account Manager', 'Sales Manager', 'Invoice Manager', 'Unit Manager', 'Payment Manager'],
    title: 'accountManagement.ledger.title',
    noCache: true,
    icon: 'chart'
  }
}, {
  path: '/ledgers/edit/:id(\\d+)',
  component: () => import('@/views/ledgers/components/EditItemWiseLedger.vue'),
  name: 'accountManagement.ledger.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'accountManagement.ledger.edit',
    noCache: true,
    activeMenu: '/ledgers/list',
    hidden: true
  }
}, {
  path: '/ledgers/info/:id(\\d+)',
  component: () => import('@/views/ledgers/components/LedgerInfoDetails.vue'),
  name: 'accountManagement.ledger.info',
  props: {
    isEdit: true
  },
  meta: {
    title: 'accountManagement.ledger.info',
    noCache: true,
    activeMenu: '/ledgers/list',
    hidden: true
  }
}, {
  path: '/ledgers/add/',
  component: () => import('@/views/ledgers/manage.vue'),
  name: 'accountManagement.ledger.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'accountManagement.ledger.add',
    noCache: true,
    activeMenu: '/ledgers/list',
    hidden: true
  }
}, {
  path: '/ledgers/addCnDn/',
  component: () => import('@/views/ledgers/components/AddCnDn.vue'),
  name: 'orderManagement.ledger.addCnDn',
  props: {
    isEdit: false
  },
  meta: {
    title: 'orderManagement.ledger.addCnDn',
    noCache: true,
    activeMenu: '/ledgers/list',
    hidden: true
  }
}, {
  path: '/ledgers/pending-ledgers/',
  component: () => import('@/views/ledgers/pending-ledgers-list.vue'),
  name: 'accountManagement.ledger.pendingLedgers',
  meta: {
    title: 'accountManagement.ledger.pendingLedgers',
    roles: ['Super Admin', 'Payment Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Account Manager'],
    noCache: true,
    hidden: false,
    icon: 'skill'
  }
}, {
  path: '/ledgers/approved-ledgers/',
  component: () => import('@/views/ledgers/approved-ledgers-list.vue'),
  name: 'accountManagement.ledger.approvedLedgers',
  meta: {
    title: 'accountManagement.ledger.approvedLedgers',
    roles: ['Super Admin', 'Payment Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Account Manager'],
    noCache: true,
    hidden: false,
    icon: 'tax'
  }
}, {
  path: '/ledgers/request-approval-ledgers/',
  component: () => import('@/views/ledgers/request-approval-ledgers-list.vue'),
  name: 'accountManagement.ledger.requestApprovalLedgers',
  meta: {
    title: 'accountManagement.ledger.requestApprovalLedgers',
    roles: ['Super Admin', 'Account Manager'],
    noCache: true,
    hidden: false,
    icon: 'tax'
  }
}, {
  path: '/ledgers/request-approval-edit/:id(\\d+)',
  component: () => import('@/views/ledgers/components/RequestApprovalLedgersDetails.vue'),
  name: 'accountManagement.ledger.requestApprovalEdit',
  meta: {
    title: 'accountManagement.ledger.requestApprovalEdit',
    roles: ['Super Admin', 'Account Manager'],
    noCache: true,
    hidden: true
  }
}, {
  path: '/orders-dispatches/outstanding-list',
  component: () => import('@/views/orders-dispatches/outstanding-list.vue'),
  name: 'inventoryManagement.dispatch.outstanding',
  meta: {
    title: 'inventoryManagement.dispatch.outstanding',
    roles: ['Super Admin', 'Admin', 'Agent', 'Read Only', 'Account Manager'],
    noCache: true,
    hidden: false,
    icon: 'table'
  }
}, {
  path: '/orders-dispatches/advance-list',
  component: () => import('@/views/orders-dispatches/advance-list.vue'),
  name: 'inventoryManagement.dispatch.advance',
  meta: {
    title: 'inventoryManagement.dispatch.advance',
    roles: ['Super Admin', 'Admin', 'Agent', 'Read Only', 'Account Manager'],
    noCache: true,
    hidden: false,
    icon: 'tab'
  }
}, {
  path: '/ledgers/payment-type-ledgers',
  component: () => import('@/views/ledgers/payment-type-ledger-list.vue'),
  name: 'accountManagement.ledger.paymentTypeWise',
  meta: {
    title: 'accountManagement.ledger.paymentTypeWise',
    roles: ['Super Admin', 'Read Only'],
    noCache: true,
    hidden: false,
    icon: 'table'
  }
}, {
  path: '/ledgers/overdue-invoices',
  component: () => import('@/views/ledgers/overdue-invoices-list.vue'),
  name: 'accountManagement.ledger.overdueInvoices',
  meta: {
    title: 'accountManagement.ledger.overdueInvoices',
    roles: ['Super Admin'],
    noCache: true,
    hidden: false,
    icon: 'table'
  }
}];